export default {
  avatar: {
    title: "Alterar Avatar",
  },
  bindRole: {
    allServers: "Todos os servidores",
    bindFailed: "Falha ao vincular personagem",
    bindSuccess: "Personagem vinculado",
    getRoleListFailed: "Falha ao recuperar lista de personagens",
    getServerListFailed: "Falha ao recuperar lista de servidores",
    modifyTitle: "Alterar Personagem Vinculado",
    noRole: "Nenhum personagem disponível",
    recentServers: "Seu Servidor",
    role: "Nome do Personagem:",
    rolePlaceholder: "Selecionar Personagem",
    server: "Servidor:",
    serverPlaceholder: "Selecionar Servidor",
    title: "Vincular Personagem",
  },
  commentModal: {
    placeholder: "Escreva um comentário...",
    replyTo: "Responder a {username}",
    title: "Comentar",
  },
  common: {
    cancel: "Cancelar",
    confirm: "OK",
    landscapeTip:
      "Por favor, gire o seu telemóvel para o modo retrato para uma melhor experiência",
    loadMore: "Deslize para cima para carregar mais",
    loading: "Carregando...",
    loadingMore: "Carregar mais...",
    noMore: "Não há mais dados",
    refreshFailed: "Falha ao atualizar",
    refreshSuccess: "Atualizado",
    submit: "Enviar",
    all: "Todos",
    language: "Idioma",
  },
  error: {
    50002: "Token inválido ou expirado",
    50006: "O apelido já foi escolhido por outro usuário",
    50007:
      "Só pode alterar o seu nome de utilizador uma vez por mês, já o alterou este mês",
    50008: "Pontos insuficientes",
    50301: "Você não tem permissão para postar",
    50302: "Limite de postagem atingido",
    50303: "O comprimento do conteúdo não atende aos requisitos",
    50304:
      "O conteúdo contém palavras sensíveis, por favor, modifique e tente novamente",
    50308: "Você não tem permissão para visualizar esta postagem",
    50309: "Post foi excluído ou movido",
    50351: "Tópico está fechado, não é possível responder",
    50353: "Você não tem permissão para responder",
    50354: "Respostas são proibidas nesta seção",
    50355:
      "Postando com muita frequência, por favor, tente novamente mais tarde",
    50356: "Limite de postagem por hora atingido",
    50361: "Comentário não encontrado",
    50500: "Você ainda não pode usar a função de pesquisa",
    50501: "Função de pesquisa desativada",
    50502: "O conteúdo contém palavras sensíveis, por favor, modifique e tente novamente",
    50505: "Pesquisa demasiado frequente, por favor tente novamente mais tarde",
    50703: "Falha na revisão da imagem",
    50704: "O conteúdo da imagem não atende aos padrões",
    50214: "Falha ao compartilhar: você não entrou em nenhuma @:shareModal.alliance.",
    common: "Falha na operação, tente novamente mais tarde.",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "Conectado",
    loginInSuccess: "Login bem-sucedido",
    pleaseLogin: "Faça o login primeiro.",
    loginNow: "Entrar",
    pullToRefresh: "Deslize para baixo para atualizar",
    releaseToRefresh: "Solte para atualizar",
    signFailed: "Falha no login",
    signIn: "Entrar",
    signInFailedTip: "Falha no login, tente novamente mais tarde",
    signSuccess: "Login bem-sucedido",
    goToShop: "Ir para o Centro de Pontos",
    sortByLastPost: "Comentários recentes",
    sortByTime: "Mais recentes",
    tags: {
      activity: "Evento",
      chats: "Discutir",
      guide: "Guiar",
      recommend: "Recomendar",
      news: "Notícias",
    },
    unboundRole: "Personagem não vinculado",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "Em manutenção",
    message:
      "Desculpe, o fórum do jogo está atualmente em manutenção. Por favor, tente novamente mais tarde.",
  },
  mentionModal: {
    searchPlaceholder: "Pesquisar usuário",
    title: "Selecionar usuário",
  },
  nicknameModify: {
    alreadyRenamed:
      "O apelido só pode ser alterado uma vez por mês e você já o alterou este mês.",
    changedNickname: "Alterar apelido",
    cost: "Custo",
    date: "Data",
    getMore: "Obter",
    nicknameTooShort: "O apelido deve ter pelo menos 3 caracteres",
    coinNotEnough: "Pontos insuficientes",
    placeholder: "Por favor, insira um apelido",
    recordTitle: "Editar Histórico",
    sameNickname: "O novo apelido não pode ser igual ao atual.",
    success: "Alteração salva",
    viewRecord: "Editar Histórico",
  },
  notice: {
    empty: "Nenhuma mensagem ainda",
    likeComment: "{username} gostou do seu comentário",
    likePost: "{username} curtiu sua postagem",
    mentionComment: "{username} mencionou o seu comentário",
    mentionPost: "{username} mencionou a sua publicação",
    replyComment: "{username} respondeu ao seu comentário",
    replyPost: "{username} respondeu à sua publicação",
    system: "Notificação do Sistema",
    tabs: {
      like: "Curtir",
      mention: "Me mencionou",
      notification: "Notificação",
      reply: "Respondeu para mim",
    },
    title: "Notificação de Mensagem",
  },
  operateModal: {
    confirmDelete: "Tem certeza de que deseja excluir esta postagem?",
    copyFailed: "Falha ao copiar",
    copyLink: "Copiar Link",
    copySuccess: "Copiado",
    delete: "Excluir",
    shareToGame: "Compartilhar no jogo",
    deleteFailed: "Falha ao excluir",
    deleteSuccess: "Exclusão Concluída",
    title: "Ação",
  },
  shareModal: {
    selectChannelTitle: "Selecione o canal para compartilhar",
    channelLabel: "Canal",
    channelPlaceholder: "Selecione o canal",
    alliance: "Aliança",
    shareSuccess: "Compartilhado com sucesso",
    continueBrowse: "Continuar navegando",
    goToGame: "Ver no jogo",
    noThreadTip: "Abra uma publicação primeiro",
  },
  post: {
    create: {
      contentEmpty: "O conteúdo não pode estar vazio",
      contentPlaceholder: "Diga algo...",
      failed: "Falha ao postar",
      fileTooLarge: "O tamanho do arquivo excede o limite (máx. {maxSize})",
      image: "Imagem",
      imageSizeLimit: "O tamanho da imagem deve ser inferior a 5 MB",
      imageUploadFailed: "Falha ao carregar a imagem",
      imageUploadSuccess: "Imagem enviada",
      imageUploading: "Enviando imagem, por favor aguarde.",
      invalidFileType: "Tipo de arquivo não suportado",
      maxCharsReached:
        "Limite máximo de caracteres atingido ({max} caracteres)",
      mention: "{'@'}",
      selectBoard: "Selecionar Seção",
      topicLabel: "Tópico",
      submit: "Publicar",
      submitting: "Postando...",
      success: "Postado",
      title: "Publicar",
      titleEmpty: "O título não pode estar vazio",
      titlePlaceholder: "Insira o título",
      video: "Vídeo",
      videoSizeLimit: "O tamanho do vídeo deve ser inferior a 50 MB",
      videoUploadFailed: "Falha ao carregar o vídeo",
      videoUploadSuccess: "Vídeo carregado",
      videoUploading: "Carregando vídeo, aguarde...",
    },
    title: "Publicação",
  },
  postDetail: {
    allComments: "Todas as {num} respostas",
    allReplies: "Responder a todos",
    author: "Autor",
    cancelFavorite: "Removido dos Favoritos",
    commentTooShort: "O comentário deve ter pelo menos 5 caracteres",
    translate: "Traduzir",
    translating: "Traduzindo...",
    translateSuccess: "Tradução bem-sucedida",
    translateFailed: "Falha na tradução",
    translatedTo: "Traduzido para",
    earliest: "Resposta Mais Antiga",
    favoriteSuccess: "Adicionado aos Favoritos",
    floor:
      'Nos fóruns em inglês, não existe o conceito de "andar", a expressão mais próxima de "Xº andar" é "#X"',
    latest: "Resposta Mais Recente",
    loadFailed: "Falha ao carregar",
    noContent: "Sem conteúdo",
    onlyAuthor: "Autor Apenas",
    reply: "Responder",
    replyTo: "Responder",
    sendFailed: "Falha ao enviar",
    sendSuccess: "Enviado",
    sending: "Enviando...",
    viewOriginalPost: "Postagem Original",
    writeSomething: "Diz algo...",
  },
  profile: {
    addLikeSuccess: "Curtiu",
    cancelLikeSuccess: "Não curtido",
    communityId: "ID da Comunidade",
    editNickname: "Alterar apelido",
    followSuccess: "Seguindo",
    followed: "Seguindo",
    followers: "Seguidores",
    follow: "Seguir",
    likes: "Curtidas",
    noFavorites: "Sem Favoritos",
    noPosts: "Sem Atualizações",
    shopLabel: "Loja de Pontos",
    tabs: {
      favorites: "Meus favoritos",
      posts: "Minhas atualizações",
    },
    title: "Perfil",
    unfollowSuccess: "Deixou de seguir",
  },
  search: {
    btn: "Pesquisar",
    empty: "Nenhum conteúdo relacionado",
    filter: {
      dateline: "Mais recentes",
      title: "Ordenar",
      views: "Popular",
    },
    historyTitle: "Histórico de Pesquisa",
    hotTitle: "Em Alta",
    relatedPosts: "Postagens relacionadas",
    tabs: {
      post: "Publicação",
      user: "Usuário",
    },
  },
  setting: {
    about: "Sobre Nós",
    logout: "Sair",
    logoutSuccess: "Desconectado",
    privacy: "Política de Privacidade",
    service: "Termos de Serviço",
    title: "Configurações",
  },
  shop: {
    emptyTip: "Loja em construção, fique atento",
    record: "Histórico de Câmbio",
    title: "Central de Câmbio",
    bindRole: "Vincular personagem",
    switchRole: "Trocar personagem",
    tabs: {
      tasks: "Tarefas de pontos",
      rewards: "Troca de recompensas",
    },
    taskInProgress: "Em progresso",
    taskCompleted: "Concluído",
    goToComplete: "Missão",
    exchange: "Trocar",
    exchanged: "Trocado",
    exchangeConfirmTitle: "Confirmar troca?",
    currentCoins: "Pontos atuais",
    costCoins: "Pontos a consumir",
    receiveRole: "Personagem destinatário",
    exchangeSuccess: "Troca bem-sucedida",
    exchangeFailed: "Troca falhou",
  },
  exchangeRecord: {
    time: "Tempo",
    content: "Conteúdo",
    points: "Pontos",
    empty: "Nenhum registro de troca",
  },
  tabBar: {
    home: "Início",
    notice: "Mensagem",
    profile: "Meu",
  },
  time: {
    hoursAgo: "há {hours} horas",
    minutesAgo: "há {minutes} minutos",
  },
};
